class CreditworthinessMobileHeaderController {
  constructor() {
  }
}

export default CreditworthinessMobileHeaderController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMobileHeader/creditworthinessMobileHeader.controller.js